import { useQueryClient } from '@tanstack/react-query';
import { postV1MessagingChannelsIdReply } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import { MessagingChannel } from '~hooks/useMessaging/models';
import { MESSAGING_CHANNELS_QUERY_KEY } from '~queries/messagingQueryKeys';
import connection from '~services/connectionModule';

/** `/reply` posts nothing — it only answers where this member's reply would land. */
export default function useReplyPrivately() {
  const queryClient = useQueryClient();

  const replyPrivately = useCallback(
    async (channel: MessagingChannel) => {
      try {
        const response = await postV1MessagingChannelsIdReply({
          path: { id: channel.id },
        });
        const privateChannel = MessagingChannel.parse(response.data.data);

        // The first reply creates the 1:1, and a bare channel with no message in it yet is
        // announced by nothing on the socket — so the list only learns of it from here.
        await queryClient.invalidateQueries({ queryKey: MESSAGING_CHANNELS_QUERY_KEY });

        return privateChannel;
      } catch (error) {
        connection.handleRequestError(
          error,
          t('error_messages.messaging.failed_to_open_private_reply'),
        );
        throw error;
      }
    },
    [queryClient],
  );

  return { replyPrivately };
}
